import type * as recall from '@otter-ai/recall-client';
import { atom } from 'jotai';

const SESSION_STORAGE_KEY = 'initialTemplate';

export type NewTemplate = Omit<recall.Template, 'id'>;
export const initialTemplateAtom = atom<NewTemplate | null>(
  getInitialTemplate(),
);

// TODO(sleahy): Pass the current template through the URL instead of using sessionStorage
// This is a solution where the user creates a template from the meeting insights page.
// The information is stored in an atom, but when we reload the page, the atom is not populated.
function getInitialTemplate(): NewTemplate | null {
  if (typeof sessionStorage === 'undefined') return null;

  const initialValue = sessionStorage.getItem(SESSION_STORAGE_KEY);
  return initialValue ? JSON.parse(initialValue) : null;
}
